templateCache = {}

module.exports = ($scope, $uibModalInstance, $sce, Api, entity, starredDoc, result, project) ->
  $scope.entity = entity
  $scope.starredDoc = starredDoc
  $scope.result = result
  $scope.project = project
  $scope.iframeLoaded = false
  $scope.onIframeLoad = () ->
    $scope.iframeLoaded = true

  $scope.getTrustedUrl = (result) ->
    if not result then return
    if result.shouldBeTranslated()
      link = result.translated_url + '&framed=false'
    else
      link = result.get_absolute_url + '?framed=false'
    if !templateCache[link]
      templateCache[link] = $sce.trustAsResourceUrl(link)

    return templateCache[link]

  $scope.onModalClose = ->

  $scope.close = () ->
    if $scope.onModalClose() then return
    $uibModalInstance.close 'saved'

  $scope.cancel = ->
    if $scope.onModalClose() then return
    $uibModalInstance.dismiss 'cancel'
